import Pickups from '@mui/icons-material/DeliveryDiningOutlined';
import Container from '@mui/material/Container';
import { useTranslation } from 'react-i18next';

import SectionTitle from '@/components/SectionTitle/SectionTitle';
import usePageTitle from '@/hooks/usePageTitle';
import PickupSection from '@/sections/Pickups';

const Pickup = () => {
  usePageTitle('Recolecciones');

  const { t } = useTranslation('pickup');

  return (
    <Container maxWidth="xxl">
      <SectionTitle title={t('TITLE')} mt={5}>
        <Pickups fontSize="large" />
      </SectionTitle>

      <PickupSection />
    </Container>
  );
};

export default Pickup;
